<template>
  <vs-chip :color="getStatusColor(value)" class="product-order-status">
    <div class="checkbox mr-3">
      <label>
        <input
          type="checkbox"
          :checked="value === 1"
          @change="change($event)"
        />{{ value === 1 ? textoCaso1 : textoCaso0 }}</label
      >
    </div>
  </vs-chip>
</template>

<script>
export default {
    props: {
        value: Object,
        textoCaso0: String,
        textoCaso1: String
    },
    methods: {
        getStatusColor(status) {
            if (status === 1) return "success";
            if (status === 0) return "warning";
        },
        change(event) {
            this.$emit('change', event)
        }
    }
};
</script>

<style lang="scss">
.text-chip.vs-chip--text {
  label {
    display: flex;
    align-items: center;
  }

  input {
    margin-right: .5rem;
  }
}
</style>